import { Component, Injector, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { AdminService } from 'src/app/service/admin/AdminService';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProgressService } from 'src/app/service/ProgressService';
import { User } from 'src/app/model/user';
import { Subscription } from 'rxjs';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';

@Component({
    selector: 'reset-win-reg-lock',
    templateUrl: './reset-win-reg-lock.component.html',
    styles: [
    ]
})
export class ResetWinRegLockComponent extends BaseComponent implements OnInit {
    @ViewChild('pageMsg') pageMsgElement: ElementRef;
    @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
    errorCode: string;
    resetWinForm: FormGroup;
    submitted: boolean = false;
    restSub: Subscription;
    email: string;
    appErrorPrefix: string = 'bss.api.error';
    pageMsgRendered: boolean;
    canceled = false;
    constructor(
        public progressService: ProgressService,
        public rest: AdminService,
        injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.resetWinForm = new FormGroup({
            email: new FormControl(null,
                Validators.compose([Validators.required, PasswordValidator.invalidEmail])),
        });
    }


    onSubmit() {
        this.submitted = true;
        if (this.resetWinForm.invalid) {
            return;
        }
        this.callResetWINApi();
    }


    callResetWINApi() {
        this.errorCode = null;
        this.email = this.resetWinForm.get('email').value;
        this.pageMsgRendered = false;
        this.progressService.open();
        this.restSub = this.rest.resetWINAttempts(this.email).subscribe((response) => {
            // console.log('get-data:' + JSON.stringify(response));
            if (response.result > 0) {
                this.appError = true;
                this.appSuccess = false;
                this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
            } else {
                this.appError = false;
                this.appSuccess = true;

            }
        }, (error) => { this.processError(error) },

            () => {

                this.progressService.close();

            });
    }

    ngOnDestroy() {
        if (this.restSub) {
            this.restSub.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
    }

    ngAfterViewChecked() {
        if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
            this.pageMsgElement.nativeElement.focus();
            this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
            this.pageMsgRendered = true;
        }
    }
    onNewSearch(): void {
        this.newSearch();
    }

}